import { LogInIcon } from 'vue-feather-icons'

export default {
  name: 'UserSignIn',
  props: ['user', 'signOutFn', 'openSignInModalFn'],
  components: { LogInIcon }
}
